import { forwardRef } from 'react'
import classNames from 'classnames'
import type { ComponentPropsWithRef } from 'react'
import type { CommonProps } from '../@types/common'

export interface TFootProps extends ComponentPropsWithRef<'tfoot'>, CommonProps {}

const TFoot = forwardRef<HTMLTableSectionElement, TFootProps>((props, ref) => {
    const { children, className, ...rest } = props

    const tfootClass = classNames(className)

    return (
        <tfoot ref={ref} className={tfootClass} {...rest}>
            {children}
        </tfoot>
    )
})

TFoot.displayName = 'TFoot'

export default TFoot 